export const moduleId = 'accounting-books'


export const state = {
    isView: ''
}

export const mutations = {
    setIsView(state, type) {
        state.isView = type
    }
}


export const actions = {



}


// WEBPACK FOOTER //
// ./src/store/modules/record-management/accounting-books/index.js